/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import * as _l from 'lodash';

import { AlertEventInfo } from 'services/lib/dto/AlertEventInfo';

import './activity.scss';
import './activity.tpl.html';

angular
  .module('log.activity', [
    'services.alertEvents',
    'services.bulkrestoredata',
    'services.error',
    'services.util',
    'services.permissions',
    'services.activity'
  ])
  .constant('BACKUP_TYPES', {
    BULK_RESTORE: 'BULK_RESTORE',
    BULK_RESTORE_CSV_VERIFICATION: 'BULK_RESTORE_CSV_VERIFICATION',
    BULK_RESTORE_PREVIEW: 'BULK_RESTORE_PREVIEW',
    CROSS_ORG_RESTORE: 'CROSS_ORG_RESTORE',
    CUSTOM_TIME_BACKUP: 'CUSTOM_TIME_BACKUP',
    DOWNLOAD_BATCH_OUTPUT: 'DOWNLOAD_BATCH_OUTPUT',
    EXPORT: 'EXPORT',
    MANUAL_BACKUP: 'BACKUP_MANUAL_TEMPLATE',
    METADATA_COMPARE: 'METADATA_COMPARE',
    METADATA_RESTORE: 'METADATA_RESTORE',
    OBJECT_RESTORE: 'OBJECT_RESTORE_TEMPLATE',
    SCHEDULED_BACKUP: 'BACKUP_SCHEDULED_TEMPLATE'
  })
  .constant('ACTIVITY_TYPE_ICON_CLASS', {
    FAILURE: 'sbsf-activity-red-x sca-icon-x-gray',
    SUCCESS: 'sbsf-activity-check  sbsf-activity-check-gray sca-icon-check-gray',
    PARTIAL: 'sbsf-activity-exclamation sca-icon-incomplete-gray'
  })
  /**
   * Controller for the log.activity template.
   */
  .controller(
    'ActivityLogCtrl',
    function (
      $scope,
      $filter,
      $window,
      $rootScope,
      $q,
      batchUtils,
      pagingUtils,
      AlertEventService,
      ErrorService,
      UtilService,
      BulkRestoreType,
      httpActivities,
      UserAgentFactory,
      permissionService,
      activityUtils,
      BACKUP_TYPES,
      ACTIVITY_TYPE_ICON_CLASS,
      RESULT_KEYS,
      ALERT_EVENTS,
      VIEW_STATES
    ) {
      const i18n = $filter('i18n');
      const pluralize = $filter('pluralize');

      $scope.getAlertClass = getAlertClass;
      $scope.getEventDescription = getEventDescription;
      $scope.getIconClass = getIconClass;
      $scope.getMessage = getMessage;
      $scope.isBackup = isBackup;
      $scope.loadAlertEvents = loadAlertEvents;
      $scope.updateActivities = updateActivities;

      $scope.totalItems = pagingUtils.pagingInfo.activity.totalItems;
      $scope.activities = pagingUtils.pagingInfo.activity.items;
      $scope.activityHistoryDownloadInProgress = $rootScope.activityHistoryDownloadInProgress;

      $scope.activityHistoryCsvTooltip = i18n('ACTIVITY_HISTORY_CSV_TOOLTIP');

      $scope.headerValues = {
        date: 'date',
        duration: 'duration',
        result: 'percentComplete',
        type: 'type'
      };
      $scope.reverse = true;

      $scope.maxSize = 0;
      $scope.itemsPerPage = pagingUtils.pagingInfo.activity.itemsPerPage;
      $scope.totalPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);

      // Paging params
      pagingUtils.pagingInfo.activity.sortBy = $scope.headerValues.date;
      pagingUtils.pagingInfo.activity.ascending = !$scope.reverse;
      $scope.pagingParam = pagingUtils.pagingInfo.activity;

      // Need to keep track of current page just in case we get bad input and need to reset.
      $scope.currentPage = 1;

      // See if any of the backups generated alerts
      $scope.showActivityLogMask = true;
      $scope.loadAlertEvents().finally(() => {
        $scope.showActivityLogMask = false;
      });

      /**
       * Determines whether any backup generated alerts.
       *
       * @returns {Promise} the promise of completion.
       */
      function loadAlertEvents() {
        const promises = [];

        _l.each($scope.activities, (activity) => {
          if (isBackup(activity)) {
            const promise = AlertEventService.getEventsForBatch(activity.batchId)
              .then((events) => {
                activity.events = events;
              })
              .catch(function (err) {
                ErrorService.report(err);
              });

            promises.push(promise);
          }
        });

        return $q.all(promises);
      }

      /**
       * Determines whether an activity is a backup activity.
       *
       * @param {object} activity - the activity to check.
       * @returns {boolean} true if the activity is a type of backup.
       */
      function isBackup(activity) {
        // You would think that BACKUP_TYPES would contain these values, but the values there are something different.
        // Those are also BATCH types, not BACKUP types...
        return (
          activity.type === 'CUSTOM_TIME_BACKUP' ||
          activity.type === 'MANUAL_BACKUP' ||
          activity.type === 'SCHEDULED_BACKUP'
        );
      }

      /**
       * Refreshes the list of activities.
       *
       * @returns {Promise} the promise of completion
       */
      function updateActivities() {
        $scope.showActivityLogMask = true;

        pagingUtils.updateActivities($scope.pagingParam);

        return pagingUtils
          .getActivities()
          .then(function () {
            $scope.totalItems = pagingUtils.pagingInfo.activity.totalItems;
            $scope.activities = pagingUtils.pagingInfo.activity.items;
            $scope.totalPages = pagingUtils.pagingInfo.activity.totalPages;

            return $scope.loadAlertEvents();
          })
          .finally(() => {
            $scope.showActivityLogMask = false;
          });
      }

      /**
       * Utility to update the current page selected and fetch activities.
       *
       * @param {Number} pageNo - The page number to update the current page.
       * @returns {Promise} the promise of completion
       */
      $scope.setPage = function (pageNo) {
        const page = pagingUtils.getCurrentPage(pageNo, $scope.totalPages) || $scope.currentPage;
        if (page === $scope.currentPage) {
          //if page number didn't change then ignore setPage request
          $scope.pagingParam.currentPage = page;
          return;
        }
        // todo: unit test this.
        if (page) {
          $scope.pagingParam.currentPage = page;
          $scope.currentPage = page;
        }

        return $scope.updateActivities();
      };

      /**
       * Debounced set page function
       */
      $scope.setPageDebounced = _.debounce($scope.setPage, 500);

      /**
       * Determines the alert class for an activity. Only backups can have alerts.
       *
       * @param {object} activity - the activity whose alert class is desired.
       * @returns {string} - the icon class
       */
      function getAlertClass(activity) {
        return isBackup(activity) && _.size(activity.events) > 0 ? 'sbsf-backup-alert' : '';
      }

      /**
       * Returns the description of an alert event.
       *
       * @param {object} event - the event whose description is desired.
       * @returns {string} - the description
       */
      function getEventDescription(event) {
        return AlertEventInfo.getDescription(event);
      }

      /**
       * Determines the icon class for an activity
       *
       * @param {object} activity - the activity whose icon class is desired.
       * @returns {string} - the icon class
       */
      function getIconClass(activity) {
        return ACTIVITY_TYPE_ICON_CLASS[activity.status] || ACTIVITY_TYPE_ICON_CLASS.PARTIAL;
      }

      /**
       * Function used to build the type message shown in the activity table.
       *
       * @param {Object} activity - An action object return from the server.
       *
       * @returns {*|string} A html code block.
       */
      function getMessage(activity) {
        const errorText = pluralize(activity.errors, 'SINGLE_ERROR', 'NUM_ERRORS');
        const warningText = pluralize(activity.warnings, 'SINGLE_WARNING', 'NUM_WARNINGS');
        let additionalText = '';
        let typeMessage;

        if (activity.type === 'BULK_RESTORE_CSV_VERIFICATION') {
          const fileName = activity.bulkRestoreCsvVerificationData.fileName;
          additionalText = `: <span class="sbsf-filename-no-style">${fileName}</span> `;
        } else {
          additionalText = ' ';
        }

        if (activity.warnings > 0 && activity.errors > 0) {
          additionalText += i18n('PARENTHESIS_TWO_ITEMS', [errorText, warningText]);
        } else if (activity.warnings > 0) {
          additionalText += i18n('PARENTHESIS', [warningText]);
        } else if (activity.errors > 0) {
          additionalText += i18n('PARENTHESIS', [errorText]);
        }

        // Construct the downloaded message for which type was downloaded
        if (activity.type === 'DOWNLOAD_BATCH_OUTPUT') {
          typeMessage = i18n('DOWNLOADED', i18n(activity.downloadedType));
        } else if (activity.type === 'BULK_RESTORE_CSV_VERIFICATION') {
          const parentJobType = batchUtils.getParentJobTypeForCsvVerification(activity.bulkRestoreCsvVerificationData);
          typeMessage = i18n(`CSV_VERIFICATION_FOR_${parentJobType}`);
        } else if (activity.type.startsWith('GDPR')) {
          typeMessage = i18n(activity.type);
        } else {
          typeMessage = i18n(BACKUP_TYPES[activity.type]);
        }

        return typeMessage + additionalText;
      }

      /**
       * Returned the formatted date string from an
       * activity object.
       *
       * @param {string} activityDate - A string date.
       * @returns {string} A formatted date string.
       */
      $scope.getDate = function (activityDate) {
        return moment(activityDate).format('ddd,  MMM D[,] YYYY');
      };

      /**
       * Returned the formatted status string from an
       * activity object.
       *
       * @param {object} activity - The activity object.
       * @returns {string} A formatted status string.
       */
      $scope.getStatus = function (activity) {
        var statusMsg;
        if (activity.status === RESULT_KEYS.PARTIAL) {
          statusMsg = i18n('PARTIAL_MSG', activity.percentComplete);
        } else {
          statusMsg = i18n(activity.status);
        }
        return statusMsg;
      };

      /**
       * Returned the formatted time from an
       * activity object.
       *
       * @param {string} activityDate - A string date.
       * @returns {string} A formatted time string.
       */
      $scope.getTime = function (activityDate) {
        return moment(activityDate).format('hh:mm a');
      };

      /**
       * Returned the duration string for an activity object.
       *
       * @param {number} duration - The duration in seconds.
       * @returns {string} A formatted duration string.
       */
      $scope.getDuration = function (duration) {
        return moment.duration(duration, 'seconds').humanize(false);
      };

      $scope.getUsernameWithEmail = function (data) {
        if (!data) {
          return '';
        }
        if (data.displayName && data.loginType && data.loginType.scope === 'EXTERNAL') {
          return `${data.displayName} (${data.email})`;
        } else if (data.email) {
          return `${data.username} (${data.email})`;
        }
        return data.username;
      };

      /**
       * Returns boolean whether to show up or down arrow for header.
       * @param header - The header value.
       * @returns {string} The class to use..
       */
      $scope.isSelectedHeader = function (header) {
        var headerClass = '';
        if ($scope.pagingParam.sortBy === header) {
          if ($scope.reverse) {
            headerClass = 'sbsf-log-header-desc sca-icon-down-black';
          } else {
            headerClass = 'sbsf-log-header-asc sca-icon-down-black';
          }
        }
        return headerClass;
      };

      /**
       * Sets the sort parameter to the header selected.
       *
       * @param {String} header - The header value and property to sort by.
       * @returns {Promise} the promise of completion
       */
      $scope.selectHeader = function (header) {
        $scope.reverse = !$scope.reverse;
        $scope.pagingParam.sortBy = header;
        $scope.pagingParam.ascending = !$scope.reverse;

        return $scope.updateActivities();
      };

      /**
       * Redirect the view to the batch detail view.
       */
      $scope.goToBatch = function (selectedBatch) {
        activityUtils.goToBatch(selectedBatch);
      };

      /**
       * Download a CSV of all of the activity history.
       */
      $scope.downloadActivityHistoryCsv = function () {
        if (!$scope.activityHistoryDownloadInProgress) {
          $scope.activityHistoryDownloadInProgress = true;
          $rootScope.activityHistoryDownloadInProgress = $scope.activityHistoryDownloadInProgress;

          $rootScope.$emit(ALERT_EVENTS.SUCCESS.eventName, i18n('DOWNLOAD_START'), true, null);

          httpActivities.downloadActivityHistoryCsv().then(
            function (result) {
              const fileName = `Activity-History-Log-${moment().format('MMM-D-YYYY')}.csv`;
              const browser = UserAgentFactory.detectBrowser();
              let blob;

              //If it's IE do some black magic and use custom IE specific methods (MsSaveBlob) to save this file.
              if (browser && browser.indexOf('IE') > -1) {
                if (window.navigator.msSaveOrOpenBlob) {
                  blob = new Blob([decodeURIComponent(encodeURI(result))], {
                    type: 'text/csv;charset=utf-8;'
                  });
                  navigator.msSaveBlob(blob, fileName);
                }
              } else {
                const link = document.createElement('a');
                link.setAttribute('download', fileName);
                // convert to data URI
                link.href = 'data:text/csv;charset=utf8,' + encodeURI(result);
                document.body.appendChild(link);
                link.click();
                link.remove();
              }

              $scope.activityHistoryDownloadInProgress = false;
              $rootScope.activityHistoryDownloadInProgress = $scope.activityHistoryDownloadInProgress;
              $rootScope.$emit(ALERT_EVENTS.CLOSE.eventName);
            },
            function () {
              $scope.activityHistoryDownloadInProgress = false;
              $rootScope.activityHistoryDownloadInProgress = $scope.activityHistoryDownloadInProgress;
              $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, i18n('DOWNLOAD_ERROR'), false, null);
            }
          );
        }
      };
    }
  );
